import React, { useReducer } from "react";
import { Route, Routes } from "react-router-dom";
import { projectStatusReducer, initialProjectStatusState } from "~/areas/projects/components/ProjectStatus/reducer";
import { PortalGlobalLayout } from "~/components/GlobalLayout/PortalGlobalLayout";
import RootRoutes from "~/components/RootRoutes/index";
import SpaceLoader from "~/components/SpaceLoader/SpaceLoader";
import ReloadableRouteContent from "../ReloadableRoute";
export function AuthenticatedRoutes() {
    const [projectStatusState, projectStatusDispatch] = useReducer(projectStatusReducer, initialProjectStatusState);
    const scrollAreaRef = React.useRef<HTMLDivElement>(null);
    return (<Routes>
            <Route path="*" element={<ReloadableRouteContent>
                        <SpaceLoader render={(spaceContext) => (<PortalGlobalLayout spaceContext={spaceContext} scrollAreaRef={scrollAreaRef} projectStatus={{ state: projectStatusState, dispatch: projectStatusDispatch }}>
                                    <RootRoutes spaceContext={spaceContext} scrollAreaRef={scrollAreaRef} projectStatus={{ state: projectStatusState, dispatch: projectStatusDispatch }}/>
                                </PortalGlobalLayout>)}/>
                    </ReloadableRouteContent>}></Route>
        </Routes>);
}
